import { createContext } from 'react';

export const UIVersion = createContext('descktop');